module.exports = __webpack_public_path__ + "img/finantialList.d4a8262e.png";